export default __webpack_public_path__ + "static/media/casal_5.849a93c1.jpg";